/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Picture/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Camera from './Camera/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Upload from './Upload/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Picture({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Content/Picture"
  
}) {
  let isBefore = useIsBefore()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Camera'
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let imageCaptureQuestionValueData = fromData.useDataValue({ viewPath,
context: 'imageCaptureQuestion',
})
let imageCaptureQuestionsValueData = fromData.useDataValue({ viewPath,
context: 'imageCapture',
path: 'questions',
})
let imageCaptureQuestionPromptValueData = fromData.useDataValue({ viewPath,
context: 'imageCaptureQuestion',
path: 'prompt',
})
let aggregateData = fromHelpers.label(imageCaptureQuestionValueData, imageCaptureQuestionsValueData, imageCaptureQuestionPromptValueData)
let dtPictureColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Picture.color.primary.base'
        })
let imageCaptureQuestionInstructionsValueData = fromData.useDataValue({ viewPath,
context: 'imageCaptureQuestion',
path: 'instructions',
})
let dtTypographyFontsizeL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Picture.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-1huy2K': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--o-2-1huy2K': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 textTransform="uppercase"
 data="imageCaptureQuestion"
 data="imageCapture.questions"
 data="imageCaptureQuestion.prompt"
 aggregate="helpers.js label"
 text={aggregateData}
 marginBottom={dtSpaceS}
 color={dtPictureColorPrimaryBase}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 textAlign="center"
 whiteSpace="wrap"
 fontSize={dtTypographyFontsizeL}
 marginBottom={dtSpaceXs}
 data="imageCaptureQuestion.instructions"
 text={imageCaptureQuestionInstructionsValueData}
/>
<fromFlow.When is={flowValue === 'Camera'}>
<Camera
  viewPath={`${viewPath}/Camera`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Upload'}>
<Upload
  viewPath={`${viewPath}/Upload`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}